/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleRpcStatus } from './GoogleRpcStatus';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusFromJSONTyped,
  GoogleRpcStatusToJSON,
  GoogleRpcStatusToJSONTyped,
} from './GoogleRpcStatus';

/**
 * Required input. Pipeline object with updated fields.
 * pipeline_id is required to identify the pipeline.
 * Mutable fields: display_name, tags.
 * @export
 * @interface PipelineServiceUpdatePipelineRequest
 */
export interface PipelineServiceUpdatePipelineRequest {
  /**
   * Required if name is not provided. Pipeline display name provided by user.
   * @type {string}
   * @memberof PipelineServiceUpdatePipelineRequest
   */
  display_name?: string;
  /**
   * Required if display_name is not provided. Pipeline name provided by user.
   * @type {string}
   * @memberof PipelineServiceUpdatePipelineRequest
   */
  name?: string;
  /**
   * Optional input field. A short description of the pipeline.
   * @type {string}
   * @memberof PipelineServiceUpdatePipelineRequest
   */
  description?: string;
  /**
   * Output. Creation time of the pipeline.
   * @type {Date}
   * @memberof PipelineServiceUpdatePipelineRequest
   */
  created_at?: Date;
  /**
   * Input. A namespace this pipeline belongs to.
   * Causes error if user is not authorized to access the specified namespace.
   * If not specified in CreatePipeline, default namespace is used.
   * @type {string}
   * @memberof PipelineServiceUpdatePipelineRequest
   */
  namespace?: string;
  /**
   *
   * @type {GoogleRpcStatus}
   * @memberof PipelineServiceUpdatePipelineRequest
   */
  error?: GoogleRpcStatus;
  /**
   * Optional. User-defined tags as key-value pairs associated with the pipeline.
   * Tags can be used to label and categorize pipelines.
   * Constraints:
   *   - Maximum 20 tags per pipeline.
   *   - Both key and value are limited to 63 characters.
   *   - Keys cannot be empty and must not contain the '.' character.
   * Tags can be filtered on when listing pipelines using the filter parameter
   * with keys prefixed by "tags."
   * (e.g., filter predicate key "tags.team" with string_value "ml-ops").
   * @type {{ [key: string]: string; }}
   * @memberof PipelineServiceUpdatePipelineRequest
   */
  tags?: { [key: string]: string };
}

/**
 * Check if a given object implements the PipelineServiceUpdatePipelineRequest interface.
 */
export function instanceOfPipelineServiceUpdatePipelineRequest(
  value: object,
): value is PipelineServiceUpdatePipelineRequest {
  return true;
}

export function PipelineServiceUpdatePipelineRequestFromJSON(
  json: any,
): PipelineServiceUpdatePipelineRequest {
  return PipelineServiceUpdatePipelineRequestFromJSONTyped(json, false);
}

export function PipelineServiceUpdatePipelineRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PipelineServiceUpdatePipelineRequest {
  if (json == null) {
    return json;
  }
  return {
    display_name: json['display_name'] == null ? undefined : json['display_name'],
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    namespace: json['namespace'] == null ? undefined : json['namespace'],
    error: json['error'] == null ? undefined : GoogleRpcStatusFromJSON(json['error']),
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function PipelineServiceUpdatePipelineRequestToJSON(
  json: any,
): PipelineServiceUpdatePipelineRequest {
  return PipelineServiceUpdatePipelineRequestToJSONTyped(json, false);
}

export function PipelineServiceUpdatePipelineRequestToJSONTyped(
  value?: PipelineServiceUpdatePipelineRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    display_name: value['display_name'],
    name: value['name'],
    description: value['description'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    namespace: value['namespace'],
    error: GoogleRpcStatusToJSON(value['error']),
    tags: value['tags'],
  };
}
